import { EnvironmentConfig } from './environment.config';

export const environment: EnvironmentConfig = {
    production: false,
    defaultTenant: '3a140c21-a7a8-4bd0-81f0-680a60a8c831',
    baseApiUrl: 'https://my-test.open.limo/api',
    auth: {
        authority: 'https://auth-test.open.limo',
        redirectUrl: 'http://localhost:7000',
        clientId: 'oc_customer_web_v1',
        changePassPath: '/Account/ChangePassword',
    },
    dateSettings: {
        dateTimeFormat: 'MMM Do YYYY h:mm a',
        dateFormat: 'MMM Do YYYY',
        timeFormat: 'h:mm a',
    },
    typeaheadMinLength: 1,
    typeaheadWaitMs: 500,
};
